import { AfterViewInit, Component, TemplateRef, ViewChild } from '@angular/core';
import { NgModel } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { catchError, of, Subject, takeUntil } from 'rxjs';
import { AccountService } from 'src/app/services/account.service';
import { OtherService } from 'src/app/services/other.service';

@Component({

  selector: 'app-specialist-verification',

  templateUrl: './specialist-verification.component.html',

  styleUrls: ['./specialist-verification.component.css']

})

export class SpecialistVerificationComponent implements AfterViewInit {

  @ViewChild('detailsDialogTemplate') detailsDialogTemplate: TemplateRef<any>;
  @ViewChild('listDialogTemplate') listDialogTemplate: TemplateRef<any>;

  isSubmitDisabled = false;

  strMobile = '';

  tankerProfile = null;
  vehicles: any[] = [];

  unSubscribeAll$ = new Subject<void>();

  constructor(
    private accountService: AccountService,
    private otherService: OtherService,
    private ngbModal: NgbModal,
    private router: Router,
  ) {
    const mobile = this.router.getCurrentNavigation()?.extras.state?.returnMobile;
    if (this.otherService.isValidMobilePhoneNumber(mobile)) this.strMobile = mobile;
  }

  ngAfterViewInit(): void {
    if (this.strMobile) Promise.resolve().then(() => this.loadVehicles(false, true));
  }

  submit(strMobileField: NgModel) {
    if (strMobileField.invalid || strMobileField.pristine || this.isSubmitDisabled) {
      return;
    }
    this.loadVehicles(true, true);
  }

  loadVehicles(registerIfEmpty: boolean, openList: boolean): void {
    if (this.isSubmitDisabled) return;
    this.isSubmitDisabled = true;

    const model = {
      strMobile: this.strMobile,
      iSystemUser: this.otherService.specialistUser.iSystemUser,
      strSession: this.otherService.specialistUser.strSession
    };

    this.accountService.specialistCheckMobile(model).pipe(
      catchError(() => of(false)),
      takeUntil(this.unSubscribeAll$),
    ).subscribe((response: string | false) => {
      this.isSubmitDisabled = false;

      if (response) {
        const parsed = JSON.parse(response);
        const vehicles = (Array.isArray(parsed) ? parsed : [parsed]).filter(item => !!item);
        const result = vehicles[0];

        if (result?.ISSessionExpired === true) {
          localStorage.removeItem('specialist-info');
          this.otherService.changeSpecialistUserLogin_Status(null);
          this.ngbModal.dismissAll();
          this.accountService.toastSwal('error', 'نشست شما منقضی شده است. لطفاً دوباره وارد شوید');
          this.router.navigate(['/specialist-login']);
          return;
        }

        if (!result) {
          if (registerIfEmpty) this.registerNew();
          else {
            this.vehicles = [];
            if (openList) this.openListDialog();
          }
          return;
        }
        if (result.iResult === 0) {
          return this.accountService.toastSwal('error', result.strError);
        }

        this.vehicles = vehicles;
        if (openList) this.openListDialog();
      } else {
        this.accountService.toastSwal('error', 'خطایی رخ داد');
      }
    });
  }

  openListDialog(): void {
    this.ngbModal.open(this.listDialogTemplate, { scrollable: true, container: 'app-specialist-verification', modalDialogClass: 'details-dialog vehicle-list-dialog', centered: true, animation: false });
  }

  registerNew(): void {
    this.ngbModal.dismissAll();
    this.router.navigate(['/specialist-registration'], { queryParams: { mobile: this.strMobile } });
  }

  openDetailsDialog(vehicle: any): void {
    this.tankerProfile = vehicle;
    this.ngbModal.open(this.detailsDialogTemplate, { scrollable: true, container: 'app-specialist-verification', modalDialogClass: 'details-dialog vehicle-list-dialog', backdropClass: 'vehicle-details-backdrop', windowClass: 'vehicle-details-window', centered: true, animation: false });
  }

  unSubscribeAll(): void {
    this.unSubscribeAll$.next();
    this.unSubscribeAll$.complete();
  }

  ngOnDestroy(): void {
    this.unSubscribeAll();
  }

}
